"use client";

import { LayupProvider } from "@layuplabs/react";
import "@layuplabs/react/style.css";

const LayupOnboardingContextProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <LayupProvider
            authToken={process.env.NEXT_PUBLIC_LAYUP_API_KEY!}
            group_id="everyone" // Use "everyone" or a group ID from your admin dashboard
            theme={{ mode: "dark" }}
            guidance_endpoint="https://api.layuplabs.ai"
            isSSR>
            {children}
        </LayupProvider>
    );
};

export default LayupOnboardingContextProvider;
